import { Alert, Button, DatePicker, Drawer, Form, Select } from 'antd';
import { TruckSearchSelect } from '../../fleet/features/trucks/public/TruckSearchSelect';
import { useDeviceMappingSheet, type DeviceMappingFormValues } from '../hooks/use-device-mapping-sheet';
import { DevicePicker } from './DevicePicker';

/** Map one installation's device to a truck from a date (blank: now). Ending a mapping and adding another is how a tracker swap is recorded. */
export function DeviceMappingSheet({ onClose }: { onClose: () => void }) {
  const sheet = useDeviceMappingSheet(onClose);

  return (
    <Drawer open onClose={onClose} title="Map a device" size={480}>
      {sheet.error && <Alert className="mb-5" type="error" showIcon title={sheet.error} />}
      <Form<DeviceMappingFormValues> layout="vertical" requiredMark={false} disabled={sheet.submitting} onFinish={sheet.save}>
        <Form.Item name="integrationId" label="Integration" rules={[{ required: true, message: 'Choose an integration' }]}>
          <Select
            placeholder="Select an integration"
            optionFilterProp="label"
            showSearch
            onChange={sheet.selectIntegration}
            options={sheet.integrations.map((integration) => ({ value: integration.id, label: integration.displayName }))}
            notFoundContent="No integrations installed"
          />
        </Form.Item>
        <Form.Item name="deviceId" label="Device" rules={[{ required: true, message: 'Choose or enter a device' }]}>
          <DevicePicker devices={sheet.devices} />
        </Form.Item>
        <Form.Item name="truckId" label="Truck" rules={[{ required: true, message: 'Choose a truck' }]}>
          <TruckSearchSelect />
        </Form.Item>
        <Form.Item name="effectiveFrom" label="From" extra="Leave blank for now.">
          <DatePicker showTime className="w-full" />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" loading={sheet.submitting}>
            Map device
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
